export default {
    methods: {
        redirect() {
            window.location.reload();
        },
    },
};
